// src/LandingPage.js

// I wanna revise this script to move the video to uppper banner

import React, { useState, useEffect, useRef } from "react";
import "./LandingPage.css";
import backgroundSheet from "./robotics480.mp4";
import playVideo from "./video_audio.mp4";
import Modal from "react-modal";
import A2UIRenderer from "./A2UIRenderer";
import { Link } from "react-router-dom";

Modal.setAppElement("#root");

const LandingPage = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // Ref for the background video (robotics480.mp4)
  const backgroundVideoRef = useRef(null);
  const [isBackgroundAudioPlaying, setIsBackgroundAudioPlaying] =
    useState(true);

  // Ref for the button-controlled audio (video_audio.mov)
  const buttonAudioRef = useRef(null);
  const [isButtonAudioPlaying, setIsButtonAudioPlaying] = useState(false);
  const [isButtonAudioReady, setIsButtonAudioReady] = useState(false); // Add loading state
  const [chatInput, setChatInput] = useState("");
  const [generatedUI, setGeneratedUI] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChatSubmit = async (e) => {
    e.preventDefault();
    if (chatInput.trim()) {
      console.log("Chat submitted:", chatInput);
      setIsLoading(true);
      try {
        // Call backend API
        const response = await fetch("http://localhost:10002/api/chat", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ prompt: chatInput }),
        });

        if (response.ok) {
          const data = await response.json();
          console.log("Received A2UI data:", data);
          setGeneratedUI(data);
        } else {
          console.error("Backend error:", response.statusText);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setIsLoading(false);
        setChatInput("");
      }
    }
  };

  useEffect(() => {
    // Logic for background video audio
    const attemptPlayBackground = async () => {
      if (backgroundVideoRef.current) {
        console.log("Attempting to play background video unmuted...");
        backgroundVideoRef.current.muted = false; // Unmute initially
        try {
          await backgroundVideoRef.current.play();
          console.log("Background video playing unmuted success!");
          setIsBackgroundAudioPlaying(true);
        } catch (error) {
          console.log("Background video autoplay blocked:", error);
          // If blocked, we might need to mute it to play video at least, or wait for interaction
          backgroundVideoRef.current.muted = true;
          try {
            await backgroundVideoRef.current.play();
            console.log("Background video playing muted fallback success.");
          } catch (e) {
            console.log("Even muted play failed", e);
          }
        }
      }
    };

    // Add interaction listener to STOP background audio on first click
    const stopBackgroundAudioOnInteraction = (event) => {
      // console.log("Interaction detected:", event.type);
      if (backgroundVideoRef.current) {
        backgroundVideoRef.current.muted = true;
        // Optionally pause it if just muting isn't enough, but loop usually implies visual loop
        // backgroundVideoRef.current.pause();
        setIsBackgroundAudioPlaying(false);
        // console.log("Background video muted due to interaction.");
      }
      // Remove listeners after first interaction
      document.removeEventListener(
        "click",
        stopBackgroundAudioOnInteraction,
        true
      );
      document.removeEventListener(
        "touchstart",
        stopBackgroundAudioOnInteraction,
        true
      );
      document.removeEventListener(
        "keydown",
        stopBackgroundAudioOnInteraction,
        true
      );
      document.removeEventListener(
        "mousedown",
        stopBackgroundAudioOnInteraction,
        true
      );
    };

    attemptPlayBackground();

    // Use capture: true to ensure we catch the event before it's stopped
    document.addEventListener("click", stopBackgroundAudioOnInteraction, true);
    document.addEventListener(
      "touchstart",
      stopBackgroundAudioOnInteraction,
      true
    );
    document.addEventListener(
      "keydown",
      stopBackgroundAudioOnInteraction,
      true
    );
    document.addEventListener(
      "mousedown",
      stopBackgroundAudioOnInteraction,
      true
    );

    return () => {
      document.removeEventListener(
        "click",
        stopBackgroundAudioOnInteraction,
        true
      );
      document.removeEventListener(
        "touchstart",
        stopBackgroundAudioOnInteraction,
        true
      );
      document.removeEventListener(
        "keydown",
        stopBackgroundAudioOnInteraction,
        true
      );
      document.removeEventListener(
        "mousedown",
        stopBackgroundAudioOnInteraction,
        true
      );
    };
  }, []);

  const toggleButtonAudio = () => {
    if (buttonAudioRef.current) {
      if (isButtonAudioPlaying) {
        buttonAudioRef.current.pause();
      } else {
        buttonAudioRef.current
          .play()
          .catch((e) => console.error("Button audio play failed:", e));
      }
    }
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  return (
    <div>
      <div className="video-container">
        <div className="video-background">
          <video ref={backgroundVideoRef} loop playsInline muted={false}>
            {/* <source src="robotics480.mp4" type="video/mp4" /> */}
            <source src={backgroundSheet} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <div className="content-overlay">
        <div className="container">
          {generatedUI ? (
            <div className="generated-content" style={{ marginTop: "2rem" }}>
              <button
                onClick={() => setGeneratedUI(null)}
                style={{
                  marginBottom: "1rem",
                  padding: "8px 16px",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  border: "1px solid white",
                  color: "white",
                  borderRadius: "20px",
                  cursor: "pointer",
                }}
              >
                <i className="fas fa-arrow-left"></i> Back
              </button>
              <A2UIRenderer data={generatedUI} />
            </div>
          ) : (
            <header>
              <div className="header-top">
                <button
                  className="audio-control-btn"
                  onClick={toggleButtonAudio}
                  disabled={!isButtonAudioReady}
                  style={{
                    opacity: isButtonAudioReady ? 1 : 0.6,
                    cursor: isButtonAudioReady ? "pointer" : "wait",
                  }}
                >
                  {!isButtonAudioReady ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i> 載入中...
                    </>
                  ) : isButtonAudioPlaying ? (
                    <>
                      <i className="fas fa-volume-up"></i> 暫停音樂
                    </>
                  ) : (
                    <>
                      <i className="fas fa-volume-mute"></i> 播放音樂
                    </>
                  )}
                </button>
              </div>
              <h2>社會機器人會社</h2>
              <h1>
                <p>AI Autonoumous & Automation Agency</p>
              </h1>
              {/* Audio Element - controlled by button only */}
              <video
                ref={buttonAudioRef}
                style={{ display: "none" }}
                preload="metadata"
                onCanPlayThrough={() => setIsButtonAudioReady(true)}
                onEnded={() => setIsButtonAudioPlaying(false)}
                onPlay={() => setIsButtonAudioPlaying(true)}
                onPause={() => setIsButtonAudioPlaying(false)}
              >
                <source src={playVideo} type="video/mp4" />
              </video>
              <div className="category-grid">
                <div className="category-item">
                  <i className="fas fa-print"></i>
                  <p>Agents</p>
                </div>
                <div className="category-item">
                  <i className="fas fa-desktop"></i>
                  <p>AI services</p>
                </div>
                <div className="category-item">
                  <i className="fas fa-headphones"></i>
                  <p>機器人力資源</p>
                </div>
                <div className="category-item" onClick={openModal}>
                  <i className="fas fa-cloud-upload-alt"></i>
                  {/* <button onClick={openModal}>Play Video</button> */}

                  <p>UBI</p>
                </div>
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  contentLabel="Video Modal"
                  className="Modal"
                  overlayClassName="Overlay"
                >
                  <button onClick={closeModal}>Close</button>
                  <video width="100%" controls autoPlay>
                    <source src={playVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </Modal>
                <div className="category-item">
                  <i className="fas fa-microchip"></i>
                  <p>具身</p>
                </div>
              </div>
            </header>
          )}
          <main></main>
          <footer className="chat-footer">
            <form onSubmit={handleChatSubmit} className="chat-input-container">
              <input
                type="text"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                placeholder="Ask something about robotics..."
                className="chat-input"
              />
              <button type="submit" className="chat-submit-btn">
                <i className="fas fa-paper-plane"></i>
              </button>
            </form>
            <div className="footer-links">
              <Link to="/fb_privacy" className="footer-link">
                隱私政策
              </Link>
              <span className="footer-separator">|</span>
              <Link to="/fb_data-deletion" className="footer-link">
                資料刪除
              </Link>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
